module.exports = __webpack_public_path__ + "img/g1686608157727.a3e64a60.jpg";